<!-- 轮播图 -->
<template>
  <div class="slider-item" :style="[getStyle(), itemStyle, activeStyle]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    index: Number,
    activeIndex: Number,
    tmpIndex: Number,
    width: Number,
    size: Number,
    option: Object
  },
  data() {
    return {
      itemStyle: { transition: `transform ${this.option.speed}ms ease-out` }
    }
  },
  computed: {
    activeStyle() {
      if (
        this.option.scale !== 1 &&
        this.index === this.activeIndex + this.option.appendNum
      ) {
        return { transform: `scale(${this.option.scale})` }
      }
      return {}
    },
    activeMargin() {
      return (
        this.width * (this.option.scale - 1) * 0.5 + this.option.spaceBetween
      )
    }
  },
  created() {},
  mounted() {},
  methods: {
    getStyle() {
      const { spaceBetween, appendNum, scale, speed } = this.option
      const topRight = `0 ${this.activeMargin * 0.5}px`
      const bottomLeft = `0 ${spaceBetween * 0.5}px`
      let margin
      if (this.index === this.tmpIndex + appendNum - 1) {
        margin = `${topRight} ${bottomLeft}`
      } else if (this.index === this.tmpIndex + appendNum) {
        margin = `${topRight}`
      } else if (this.index === this.tmpIndex + appendNum + 1) {
        margin = `${bottomLeft} ${topRight}`
      } else {
        margin = `${bottomLeft}`
      }
      let transform = ''
      if (Number(scale) !== 1) {
        // 下面的逻辑其实是为goods_cross_horizontal模块做的判断 现阶段只有goods_cross_horizontal的scale > 1
        if (this.tmpIndex === -1) {
          if (this.index === appendNum - 1) {
            // copyList的第二个
            transform = `scale(${scale})`
          }
        } else if (this.tmpIndex === this.size) {
          if (this.index === this.size + appendNum) {
            // copyList的倒数第二个
            transform = `scale(${scale})`
          }
        }
      }

      return {
        width: this.width + 'px',
        margin,
        transform,
        transition: `transform ${speed}ms ease-out`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.slider-item {
  display: inline-block;
}
</style>
